import React from 'react';
import { ToastContext } from './toast-provider';

export function useToast() {
  const toastHelpers = React.useContext(ToastContext);
  return toastHelpers;
}
